import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 200px;
  padding-left: 16px;
  padding-right: 16px;
  background: #e1e1e130;
  display: flex;
  align-items: center;
  position: relative;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  border-radius: 16px;
`;

export const Logo = styled.img`
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  border: 1px solid #ededed;
  object-fit: contain;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
  border-radius: 4px;
  margin-bottom: 12px;
`;
